import confetti from 'canvas-confetti';
import { useUISettings } from 'dashboard/composables/useUISettings';

export function useConfetti() {
  const { uiSettings } = useUISettings();

  const triggerConfetti = () => {
    if (uiSettings.value.confetti_enabled === false) return;

    confetti({
      particleCount: 100,
      spread: 160,
      origin: { x: 0.5, y: 0.5 },
      startVelocity: 30,
      gravity: 0.5,
      ticks: 200,
      scalar: 1.2,
    });
  };

  return { triggerConfetti };
}
